import Vue from 'vue';
import Vuex from 'vuex';

import vehicle from './vehicle';
import application from './application';
import order from './order';
import product from './product';

Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default (/* { ssrContext } */) => new Vuex.Store({
  modules: {
    vehicle,
    application,
    order,
    product,
  },

  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEV,
});
